import type { ProviderKind } from "@cmmd-forge/contracts";

import { type ProviderPickerKind } from "../../session-logic";
import type { ModelPickerRowModel } from "./ModelListRow";
import { DEFAULT_APEX_PROFILES } from "@cmmd-forge/contracts";

const PROVIDER_LABEL_PREFIXES_BY_PROVIDER: Partial<
  Record<ProviderKind | ProviderPickerKind, ReadonlyArray<string>>
> = {
  claudeAgent: ["Claude "],
  cursor: ["Cursor "],
};

function compactModelLabel(label: string, provider: ProviderKind | ProviderPickerKind): string {
  const prefixes = PROVIDER_LABEL_PREFIXES_BY_PROVIDER[provider];
  if (!prefixes) return label;
  for (const prefix of prefixes) {
    if (label.toLowerCase().startsWith(prefix.toLowerCase())) {
      return label.slice(prefix.length).trim() || label;
    }
  }
  return label;
}

function displaySelectedModelFallback(model: string, provider: ProviderKind): string | null {
  if (provider !== "apex" && provider !== "cmmd") return model.trim() || null;
  const apexProfile = DEFAULT_APEX_PROFILES.find((profile) => profile.slug === model);
  return apexProfile?.displayName ?? null;
}

export function resolveTriggerLabel(input: {
  readonly options: ReadonlyArray<ModelPickerRowModel> | undefined;
  readonly model: string;
  readonly provider: ProviderKind;
  readonly unresolvedLabel: string | undefined;
}): string | null {
  const options = input.options ?? [];
  const selectedOption = options.find((option) => option.slug === input.model);
  const rawSelectedLabel = selectedOption
    ? selectedOption.name
    : displaySelectedModelFallback(input.model, input.provider);
  const selectedModelLabel = rawSelectedLabel
    ? compactModelLabel(rawSelectedLabel, input.provider)
    : null;
  return selectedModelLabel ?? input.unresolvedLabel ?? null;
}
